import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import styled, {css} from "styled-components";
import { Trans } from "../utils/i18n";

const Label = styled.label`
    width: 100%;
    height: 100%;
    padding: 10px;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 10px;
    cursor: pointer;
    position: relative;
    transition: background-color .2s,color .2s;
    border: 2px solid ${props => props.theme.gray};
    border-radius: 5px;
    display: flex;
    text-align: left;

    ${props => props.$active && css`
        background-color: rgba(37,59,143,.05);
        border-color: ${props => props.theme.primary};
        font-size: 16px;
    `}
`;

const Left = styled.div`
  width: 60%;
  padding-right: 10px;
`;

const Right = styled.div`
  width: 40%;
`;
const Heading = styled.div`
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
    margin: 0;
`;
const Description = styled.div`
    font-size: 14px;
    line-height: 16px;
    margin: 0;
`;

class SelectCard extends React.Component {
    render() {
        const { disabled, field, input, meta: { touched, error, data } } = this.props;

        return (
            <Label $active={!!input.value && input.value !== '0'}>
                <Left>
                    <Heading>{ field.label }</Heading>
                    <Description>{ field.description }</Description>
                </Left>
                <Right>
                    <FormControl
                        error={touched && error}
                        variant="outlined"
                    >
                        <InputLabel
                            htmlFor={'select' + input.name}>
                            Quantity
                        </InputLabel>
                        <MuiSelect
                            disabled={disabled}
                            name={input.name}
                            id={'select' + input.name }
                            native
                            label={<Trans i18nKey="selectCard.quantity">Quantity</Trans>}
                            {...input}
                        >
                            {
                                field.options
                                .map((item, index) => (
                                    <option key={index} value={item.value}>{item.label}</option>
                                ))
                            }
                        </MuiSelect>
                        { touched && error && <FormHelperText>{ error }</FormHelperText> }
                    </FormControl>
                </Right>
            </Label>
        );
    }
}

export default SelectCard
